document.addEventListener('DOMContentLoaded', () => {
  // Pause/play control for the looping hero video (WCAG 2.2.2). The button's
  // name follows the video's real state, so it also reads "Play video" when
  // the browser blocks autoplay (iOS Low Power Mode, data saver).
  document.querySelectorAll('.hero-section').forEach((hero) => {
    const video = hero.querySelector('.hero-section__video');
    const button = hero.querySelector('.hero-section__pause');
    if (!video || !button) return;

    const sync = () => {
      button.setAttribute('aria-label', video.paused ? 'Play video' : 'Pause video');
      button.classList.toggle('is-paused', video.paused);
    };

    button.addEventListener('click', () => {
      if (video.paused) {
        video.play().catch(() => {});
      } else {
        video.pause();
      }
    });
    video.addEventListener('play', sync);
    video.addEventListener('pause', sync);

    sync();
    button.hidden = false;
  });
});
